import { isAxiosError } from 'axios';
import { packagesModel } from 'entities/mine-package';
import { getOwnedNftId } from 'entities/mine-package/api';
import { findKey } from 'lodash';
import { createAppAsyncThunk, logger, wagmiConfig } from 'shared';
import { getAccount } from 'wagmi/actions';

import { fetchPaymentRequest } from '../../api';
import { isAwaitingPayment, isCompletedPayment } from '../../lib';
import { actionTypes } from '../action-types';
import { actions } from '../reducer';
import { selectCurrentTokenId, selectPaymentAssets } from '../selectors';

const getPaymentRequestLogic =
  (actionType: string) =>
  async (_: void, { rejectWithValue, getState, dispatch }: any) => {
    try {
      const { data } = await fetchPaymentRequest();
      const tokenId = selectCurrentTokenId(getState());

      if (isAwaitingPayment(data) && !tokenId) {
        const { tokens } = selectPaymentAssets(getState());
        const { payload } = data;

        const id = findKey(
          tokens.byId,
          ({ address, symbol }) => symbol === payload.symbol && address === payload.currencyAddress,
        );

        if (id) dispatch(actions.setPaymentTokenId(id));
      }

      if (isCompletedPayment(data)) {
        const account = getAccount(wagmiConfig).address;

        if (account) {
          const nftId = await getOwnedNftId(account);
          dispatch(packagesModel.actions.setOwnedNftId(nftId));
        }
      }

      dispatch(actions.setPayment(data));

      return null;
    } catch (error) {
      logger(actionType, error);

      if (isAxiosError(error) && error.code === '404') {
        dispatch(actions.resetPayment());
        return null;
      }

      return rejectWithValue(error);
    }
  };

/**
 * Hotfix: Split payment request into separate thunks
 * to allow UI to subscribe to their individual loading states. (get / polling)
 * (Yes, it's a bit of a workaround.)
 */

export const checkPaymentRequest = createAppAsyncThunk(
  actionTypes.CHECK_PAYMENT_REQUEST,
  getPaymentRequestLogic(actionTypes.CHECK_PAYMENT_REQUEST),
);

export const getPaymentRequest = createAppAsyncThunk(
  actionTypes.GET_PAYMENT_REQUEST,
  getPaymentRequestLogic(actionTypes.GET_PAYMENT_REQUEST),
);
